import React, { useState, useEffect, useRef } from "react";
import { PropTypes } from "prop-types";
import { useI18n } from "../../../i18n/useI18n";
import "../accountsMagneticStyle.less";

import reactWrapper from "@harbor/elements/utils/react/wrapper";

const [HbrViewSwitcher, HbrRadioButton] = reactWrapper([
  "hbr-view-switcher",
  "hbr-radio-button"
]);

const AccountsFilter = ({ filterOverlays }) => {
  const { tViews } = useI18n('views');

  const TOGGLER = {
    ALL: "ALL",
    NEW: "NEW",
    ACTIVATED: "ACTIVE",
    NOT_ACTIVATED: "INACTIVE"
  };

  const [toggle, setToggle] = useState(TOGGLER.ALL);
  const setIntervalRefs = useRef(null);
  const handleChange = evt => {
    const swtch = evt.currentTarget;
    setToggle(swtch.value);
    clearTimeout(setIntervalRefs.current);
    setIntervalRefs.current = setTimeout(() => filterOverlays(swtch.value), 0);
  };

  // Clear the timeout when the component unmounts
  useEffect(() => {
    return () => {
      clearTimeout(setIntervalRefs.current);
    };
  }, []);
  return (
    <>
      <div className="accounts-filter-toggler">
        <span>{tViews('showOverlays')}</span>
        <HbrViewSwitcher
          value={toggle}
          name="accounts-state"
          onHbr-change={handleChange}
        >
          <HbrRadioButton value={TOGGLER.ALL} data-testid="all-accounts-toggle">
            {tViews('allAccounts')}
          </HbrRadioButton>
          <HbrRadioButton value={TOGGLER.NEW} data-testid="new-accounts-toggle">
            {tViews('newAccounts')}
          </HbrRadioButton>
          <HbrRadioButton value={TOGGLER.ACTIVATED} data-testid="active-accounts-toggle">
            {tViews('activatedAccounts')}
          </HbrRadioButton>
          <HbrRadioButton value={TOGGLER.NOT_ACTIVATED} data-testid="inactive-accounts-toggle">
            {tViews('notActivatedAccounts')}
          </HbrRadioButton>
        </HbrViewSwitcher>
      </div>
    </>
  );
};

AccountsFilter.propTypes = {
  filterOverlays: PropTypes.func
};

export default AccountsFilter;
